export default __webpack_public_path__ + "static/media/Abyssal Gale.2ea31cf2.jpg";